<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system
	import { Text, Button, Input } from '@Shelly/shelly-design-system';
	//Helpers
	import { isValidURL } from 'src/helpers/utilities';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let settings: VirtualComponentInterface['config'],
		editEnumModal = false,
		selectedEnumIndex: number = 0;

	let configUI = settings?.meta?.ui || {};
	let key = settings?.options?.[selectedEnumIndex] || '';
	let title = configUI?.titles?.[key] || '';
	let icon = configUI?.images?.[key] || '';
	let errorInputKey = false;

	const saveEnum = () => {
		if (!key?.length) {
			errorInputKey = true;
			return;
		}
		if (!settings?.options) settings.options = [];
		if (!configUI?.titles) configUI.titles = {};
		if (!configUI?.images) configUI.images = {};
		settings.options[selectedEnumIndex] = key;
		configUI.titles[key] = title;
		configUI.images[key] = icon || null;
		editEnumModal = false;
	};
</script>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_key', {
		default: 'Key',
	})}
</Text>
<Input
	size="m"
	class="mb-m"
	icon="fas fa-file-pen"
	maxlength="255"
	label={$format('input_label_sunny', { default: 'sunny' })}
	error={errorInputKey && !key?.length
		? $format('field_cannot_be_empty', {
				default: 'This field cannot be empty!',
			})
		: ''}
	bind:value={key}
	id="input-uh7zh0a"
	aria-labelledby="input-uh7zh0a"
/>
<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_title', {
		default: 'Title',
	})}
</Text>
<Input
	size="m"
	class="mb-m"
	icon="fas fa-file-pen"
	maxlength="255"
	label={$format('input_label_it_is_sunny', { default: "It's sunny" })}
	bind:value={title}
	id="input-ky5toml"
	aria-labelledby="input-ky5toml"
/>
<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_icon', {
		default: 'Icon',
	})}
</Text>
<Input
	aria-label={$format('input_icon_url', { default: 'Enter icon URL' })}
	size="m"
	class="mb-m"
	icon="fas fa-image"
	maxlength="255"
	label="https://local-server/weather-sunny.png"
	info={$format('virtual_component_title_icon_info', {
		default: "Icons will be rendered only in 'Label' view.",
	})}
	error={icon.length > 0 && !isValidURL(icon)
		? $format('enter_valid_url', {
				default: 'Invalid URLs: Please enter a valid URL!',
			})
		: ''}
	bind:value={icon}
	id="input-f0au7c9"
/>

<div class="d-flex justify-content-end mt-s">
	<Button
		size="l"
		width="full"
		class="width-md-m width-sm-full mr-s"
		variant="secondary"
		responsiveSize={{
			sm: 'm',
		}}
		on:click={() => {
			editEnumModal = false;
		}}
	>
		{$format('button_cancel', { default: 'Cancel' })}
	</Button>
	<Button
		size="l"
		width="full"
		class="width-md-m width-sm-full"
		icon="fas fa-save"
		disabled={icon.length > 0 && !isValidURL(icon)}
		responsiveSize={{
			sm: 'm',
		}}
		on:click={saveEnum}
	>
		{$format('button_save', { default: 'Save' })}
	</Button>
</div>
